<template>
<f7-page>
  <f7-navbar>
    <f7-nav-left>
      <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu"  v-on:click="togglePanelLeft"></f7-link>
      <f7-link v-on:click="gotprevStep" ><</f7-link>
      <f7-link v-on:click="gotNextStep">></f7-link>

      <f7-nav-title> {{currentStepLib}} ({{totalObject}})</f7-nav-title>
    </f7-nav-left>

    <f7-nav-right>
      <f7-link   v-on:click="toggleLockCamera" >
        <i class="icon icon-camera material-icons">camera_fill</i>
        <i v-if="lockCamera" class="icon-state icon material-icons">lock</i>
        <i v-if="lockCamera == false" class="icon-state icon material-icons">lock_open</i>

      </f7-link>

      <f7-link icon-if-ios="f7:fullscreen"  icon-if-md="material:fullscreen" v-on:click="toggleFullscreen "></f7-link>
      <f7-link icon-if-ios="f7:menu"  icon-if-md="material:menu" v-on:click="togglePanelRight"></f7-link>
    </f7-nav-right>
  </f7-navbar>

  <div id="logger"></div>
  <div id="selectionInfo"  style="display:none">
  <div id="selectionInfoIndex"><span v-on:click="unselectObject" class="close icon material-icons">close</span>{{lastSelectedObjectIndex}} <div id="selectionInfoName">{{lastSelectedObjectName}}</div></div>
    {{lastSelectedObjectLib}}
  </div>

  <div id="container3D" v-on:click="kbHide"></div>
  <canvas id="drawing"></canvas>
  <!-- <ul id="cameraControl"><li v-on:click="zoom">Zoom</li></ul> -->nvm
  <div id="loader" v-bind:class="{isLoading: isLoading }">
    <div v-if="totalRendered < totalMesh">
     <p v-if="parseFloat(totalLoaded) <0.99">Chargement de <span id="loadingIndex">{{totalMesh}} pièces</span><br/>
        <span id="totalMesh">{{Math.round(totalLoaded*100)}}%</span></p>
      <p v-if="parseFloat(totalLoaded) >= 0.99">Génération du rendu... {{Math.round(totalRendered/totalMesh * 100)}}%</p>
    </div>
      <div v-if="totalRendered >= totalMesh"><p>Affichage du rendu...</p></div>
  </div>
  <keyboard
    v-if="kbVisible"
    v-model="inputVal"
    @ok="kbHide"
    @setIndex="setIndex"
    :layouts="[
      '#1234567890{delete:backspace}|azertyuiop|qsdfghjklm|{shift:goto:1}wxcvbn,;:!|{index:goto:2}{space:space}{ok:ok}',
      '&é\'(-è_çà)={delete:backspace}|azertyuiop|qsdfghjklm|{shift:goto:0}wxcvbn?./§|{index:goto:2}{space:space}{ok:ok}',
      '{Retour:goto:0}1234567890{delete:backspace}|{MI:setIndex:MI}{M:setIndex:M}{CG:setIndex:CG}{CD:setIndex:CD}{RG:setIndex:RG}{RC:setIndex:RC}{RD:setIndex:RD}{CH:setIndex:CH}{P:setIndex:P}{T:setIndex:T}{MA:setIndex:MA}{PR:setIndex:PR}{S:setIndex:S}{MD:setIndex:MD}{RG:setIndex:RG}|{ok:ok}'
    ]" ></keyboard>

  <f7-block id="info" theme-dark>


    <f7-page>
        <f7-searchbar
        id="searchItem"
        search-container=".virtual-list"
        search-item="li"
        search-in=".item-title"
        data-layout="normal"
        @searchbar:enable="kbShow"
        @searchbar:disable="kbClose"
        @focus="kbShow"

      ></f7-searchbar>
          <div id="switchLn">
          <f7-link v-on:click="switchLn" data-ln="fr">FR</f7-link>
          <f7-link v-on:click="switchLn" data-ln="pt">PT</f7-link>
          <f7-link v-on:click="switchLn" data-ln="en">EN</f7-link>
        </div>
    <f7-list class="searchbar-not-found">
      <f7-list-item title="Nothing found"></f7-list-item>
    </f7-list>
    <f7-list
    id="itemsList"
      class="searchbar-found"
      media-list
      virtual-list
      :virtual-list-params="{ items, searchAll, renderExternal, height: $theme.ios ? 63 : 73}"
    >
      <ul>
        <f7-list-item
           v-on:click="kbHide"

          v-for="(item, index) in vlData.items"
          :key="index"
          media-item
          link="#"
          :title="item.title"
          :subtitle="item.subtitle"
          :style="`top: ${vlData.topPosition}px`"
          :data-name="item.title"


        ></f7-list-item>
      </ul>
    </f7-list>
  </f7-page>
  </f7-block>

  <f7-block id="leftPanelwrapper" left cover theme-dark>
    <f7-page>
        <f7-block class="nav-steps-wrapper">
          <f7-block-title>Etapes en cours : </f7-block-title>
          <div class="nav-steps-innerWrapper">
            <f7-list id="nav-steps">
              <f7-list-item title="initial" data-step=-1 v-on:click="goToStep"></f7-list-item>
              <f7-list-item v-for="step in steps" :key="step.step" :title="step.lib" :data-step="step.step" v-on:click="goToStep"></f7-list-item>
              <f7-list-item title="Final" data-step=-2 v-on:click="goToStep"></f7-list-item>

            </f7-list>
          </div>
        </f7-block>
        <f7-block class="nav-steps-wrapper" v-if="currentStep >=0">
          <f7-block-title >Pièces à retirer <span>à l'étape {{(parseInt(currentStep) + 1)}} </span> : ({{totalObject}})</f7-block-title>
          <div class="nav-steps-innerWrapper">
            <f7-list id="nav-steps">
              <f7-list-item v-for="(item, index) in currentStepListItem"
              :title="item.title"
              :subtitle="item.subtitle"
              :style="`top: ${vlData.topPosition}px`"
              :data-name="item.title"
                v-on:click="showObject"

              ></f7-list-item>
            </f7-list>
          </div>
        </f7-block>
    </f7-page>
  </f7-block>

</f7-page>
</template>

<script>
import visionneuse from "../js/visioneuse/visioneuse.js";


//Keyboard compenent
import keyboard from 'vue-keyboard';
import { serverBus } from '../main';

import nomenclature from "../../static/nomenclature.json"
import nomIndex from "../../static/index.json";
//
var fileToLoad = "all";
import intialItems from '../../static/export_json/all.json';
import stepsList from "../../static/steps.json";
// var fileToLoad = "test";
// import intialItems from '../../static/export_json/test.json';
// import stepsList from "../js/visioneuse/steps-test.json";

var visio;
var selectObj;

var initialObjects =stepsList[0];
// for(let i in intialItems){
//   initialObjects.push(intialItems[i].replace('.json', ''));
// }


export default {
  components: { keyboard },
  data: function() {

    const items = this.setListItem(intialItems);
    let steps = [];
    for (let i = 0; i < stepsList.length-2; i++) {
      steps.push({
        "lib": "Etapes " + (i + 1),
        "step": i,
      })
    }

    var data = {
      showDebug: false,
      locale: 'fr',
      totalMesh: 0,
      totalLoaded: 0,
      totalRendered: 0,
      isLoading: true,
      nbEtapes: 0,
      currentStep: 0,
      previousStep: 0,
      currentStepLib:"initial step",
      totalObject:intialItems.length,
      currentStepListItem :[],
      lastSelectedObjectName:"",
      lastSelectedObjectLib:"",
      lastSelectedObjectIndex:null,
      items,
      vlData: {
       items: [],
      },
      kbVisible: false,
      layout: "normal",
      input: null,
      inputVal:'',
      options: {
        useKbEvents: false,
        preventClickEvent: false
      },
      'steps': steps,
      lockCamera:true
    }
    return data;
  },
  created(){
    var self = this;

    serverBus.$on('stepChange', (step) => {
      self.currentStep = step;
      self.setStep();
    });
  },
  methods:{
    unselectObject(){
      visio.selectObj(false);
      visio.stopDrawing();
      this.$$('#selectionInfo').css("display", 'none');
    },
    showObject:function(e){
      this.$$('#selectionInfo').css("display", 'block');
      var self = this;
      let name = this.$$(e.target).closest('li').data('name');
      this.lastSelectedObjectName = name;
      console.log('sho ', this.lastSelectedObjectName);
      this.panToObjects([self.lastSelectedObjectName]);
      var objs = visio.getObjects([self.lastSelectedObjectName], true);
      console.log(objs)
      visio.selectObj(objs[0].obj);
      setTimeout(function(){
        let liY = self.$$("#selectionInfo").offset().top - 45;
        let liX  = self.$$("#selectionInfo").offset().left - self.$$('#drawing').offset().left;
        visio.startDrawingLineToObj({x:liX, y:liY}, name);
      },50);
    },
    panToObjects(names){

      for(let i in names){
        names[i] = names[i].replace(/cross/, '#');
      }
      console.log("pan to ", names);
      if(this.lockCamera){
        visio.panToObjects(names);
      }
    },
    goToStep: function(e) {
      var step = this.$$(e.target).closest('li').data('step');
      serverBus.$emit('stepChange', step);
    },
    setStep:function() {
      var self = this;
      visio.selectObj(false)

      visio.stopDrawing();
      visio.setObjectsColor("all", "reset");
      visio.setObjectsOpacity("all", 0);
      visio.stopRotation();

      self.lastSelectedObjectName = "";

      var index =  parseInt(self.currentStep);
      //setStepByMergingPreviousStep();
      setStepFull();

      self.previousStep = index;

      function setStepFull(){
        if(index == -1){
            visio.setObjectsOpacity(stepsList[0], 1);
            if(self.lockCamera)
              visio.panCam(-1003.27,921.65,-929.41,-2.44,-0.71,-2.64,-16.17,189.24,-58.85);
            return;
        }
        if(index == -2){
            visio.setObjectsOpacity(stepsList[stepsList.length - 1], 1);
            if(self.lockCamera)
              visio.panCam(-1003.27,921.65,-929.41,-2.44,-0.71,-2.64,-16.17,189.24,-58.85);
            return;
        }

        var currentStepList = stepsList[index+1];

        if(index != 0){
          var previousStepList = stepsList[index]
        }else{
          previousStepList = initialObjects;
        }
        visio.setObjectsOpacity(previousStepList, 1);

        var fileToMarkup = [];
        for(let i in previousStepList){
          let founded = false;
          for (let y in currentStepList){
            if(currentStepList[y] == previousStepList[i]){
              founded = true;
            }
          }
          if(founded == false){
            fileToMarkup.push(previousStepList[i]);
          }
        }

        var fileToHide = [];
        for(let i in initialObjects){
          let founded = false;
          for (let y in previousStepList){
            if(previousStepList[y] == initialObjects[i]){
              founded = true;
            }
          }
          if(founded == false){
            fileToHide.push(initialObjects[i]);
          }
        }

        var fileToShowUp = [];
        for(let i in currentStepList){
          let founded = false;
          for (let y in previousStepList){
            if(currentStepList[i] == previousStepList[y]){
              founded = true;
            }
          }

          if(founded == false){
            fileToShowUp.push(currentStepList[i]);
          }
        }

        self.currentStepListItem = self.setListItem(fileToMarkup);

        self.totalObject = self.currentStepListItem.length;

        if (index == -1)
          return;

        visio.setObjectsColor(fileToMarkup, 0xFF0000);
        self.panToObjects(fileToMarkup);

        visio.setObjectsOpacity(fileToHide, 0.3);

        visio.setObjectsOpacity(fileToShowUp, 1);
        visio.setObjectsColor(fileToShowUp, 0x06F43B);

      }

      function setStepByMergingPreviousStep(){

        var index = self.currentStep;

        if (index == -1){
          this.currentStepListItem = this.setListItem(intialItems);
          visio.panCam(-1003.27,921.65,-929.41,-2.44,-0.71,-2.64,-16.17,189.24,-58.85);

        }else{
          this.currentStepListItem = this.setListItem(stepsList[index]);
        }

        this.totalObject = this.currentStepListItem.length;

        let $itemsList = this.$$('#itemsList');
        $itemsList[0].f7VirtualList.replaceAllItems(this.currentStepListItem);
        $itemsList[0].f7VirtualList.update();

        if (index == -1)
          return;

        visio.setObjectsOpacity("all", 1);

        self.totalObject = stepsList[index].length;

        visio.setObjectsColor(stepsList[index], 0xFF0000);

        if(index > 0)
            visio.setObjectsOpacity(stepsList[index-1], 0.3);

        if(index > 1){
          var transparents = defineTransparentArray(index-2);
          visio.setObjectsOpacity(transparents, 0);
        }

        function defineTransparentArray(step) {
          var i = 0;
          var result = [];
          while (i <= step) {
              result = result.concat(stepsList[i]);
            i++;
          }
          return result;
        }
      }

    },
    searchAll(query, items) {
        const found = [];
        for (let i = 0; i < items.length; i += 1) {
          let foundInTitle = items[i].title.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          let foundInSubTitle = items[i].subtitle.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          if (foundInTitle || foundInSubTitle || query.trim() === '') found.push(i);
        }
        return found; // return array with mathced indexes
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    setListItem: function(newList){
      var items = [];
      var cptNop = 0;
      for (let i in newList){
          let fullName = newList[i].replace('.json', '');
          let tIndex, tName;

          if(fullName.match(/^.{1,2}[0-9]{3}$/)){
            tIndex = fullName;
          }else{
            let match = fullName.match(/.+_(.{1,2}[0-9]{3})$/)
              if(match){
                tIndex = match[1];
              }
          }
          tName = nomIndex[tIndex];

          if(this.locale == undefined)
            this.locale = "fr";

          if(!tIndex)
            cptNop ++;

          items.push({
            title:tIndex,
            subtitle:tName,
            name:tName
          })
      }
      return items;
    },
    getFolderName:function(name){
      let foldName = "";
      if(name.match(/_/)){
        name = name.split("_");
        foldName = name[0];
        name = name[1];
      }
      return [foldName,name];
    },
    getIndexName:function(name){
      let tIndex=  "";
      name = name.replace(/cross/g, '#')
      if(nomIndex[name] != undefined){
        tIndex = nomIndex[name];
        let tIndexAr = tIndex.match(/([a-zA-Z]+)([0-9]+)/);
        let tNumber = tIndexAr[2];
        let tletter = tIndexAr[1];

        // if(tNumber >= 10 && tNumber <= 100)
        //   tNumber = "0" + tNumber;
        // else if(tNumber < 10){
        //   tNumber = "00" + tNumber;
        // }

        tIndex = tletter + tNumber;
      }
        return tIndex.toUpperCase();
    },
    translateName:function(name, lang){
      let words = name.split('-');
      let tName = '';
      for (let y in words){
        let w = words[y];
        let int = w.match(/[0-9]+/);
        if(int)
          w = w.replace(int[0], "");

        if(nomenclature[w] != undefined)
            tName += nomenclature[w][lang] + " ";
        else
            tName += w + " ";

        if(int)
            tName += int[0] + " ";

      }
      return tName.replace(/cross/g,'#');
    },
    switchLn: function(e){
      var li = this.$$(e.target).closest('a');
      var ln = li.data('ln');
      this.locale = ln;
    },
    togglePanelLeft:function(e){
      var self = this;
      this.$$('#framework7-root').addClass('close-panel-right');
      this.$$('#framework7-root').toggleClass('close-panel-left');
      visio.isResising = true;
      setTimeout(function(){
        let liY = self.$$("#selectionInfo").offset().top - 45;
        let liX  = self.$$("#selectionInfo").offset().left - self.$$('#drawing').offset().left;

        visio.startDrawingLineToObj({x:liX, y:liY}, self.lastSelectedObjectName);
      },500);

    },
    togglePanelRight:function(e){
      var self = this;
      this.$$('#framework7-root').addClass('close-panel-left');
      this.$$('#framework7-root').toggleClass('close-panel-right');
      visio.isResising = true;
      setTimeout(function(){
        let liY = self.$$("#selectionInfo").offset().top - 45;
        let liX  = self.$$("#selectionInfo").offset().left - self.$$('#drawing').offset().left;

        visio.startDrawingLineToObj({x:liX, y:liY}, self.lastSelectedObjectName);
      },500);
    },
    toggleFullscreen(e){
      this.$$('#framework7-root').toggleClass('fullscreen');
      if(this.$$('#framework7-root').hasClass('fullscreen')){

        goFullscreen();
      }else{
        exitFullscreen();
      }

      function goFullscreen(){
        var docelem = document.documentElement;
        if (docelem.requestFullscreen) {
            docelem.requestFullscreen();
        }
        else if (docelem.mozRequestFullScreen) {
            docelem.mozRequestFullScreen();
        }
        else if (docelem.webkitRequestFullscreen) {
            docelem.webkitRequestFullscreen();
        }
        else if (docelem.msRequestFullscreen) {
            docelem.msRequestFullscreen();
        }
      }
        function exitFullscreen(){
          var docElm = document;
        if (docElm.exitFullscreen) {
    			docElm.exitFullscreen();
    		} else if (docElm.webkitExitFullscreen) {
            docElm.webkitExitFullscreen();
    		} else if (docElm.mozCancelFullScreen) {
    			docElm.mozCancelFullScreen();
    		} else if (docElm.msExitFullscreen) {
    			docElm.msExitFullscreen();
    		}
          }
    },
    toggleLockCamera(){
      if(this.lockCamera){
        this.lockCamera = false;
      }else {
        this.lockCamera = true;
      }
    },
    gotNextStep(){
      if(this.currentStep < stepsList.length - 3){
        this.currentStep++;
        this.setStep();
      }else{
        this.currentStep = -2;
        this.setStep();
      }
    },
    gotprevStep(){
      if(this.currentStep >= 0){
        this.currentStep--;
        this.setStep();
      }
    },
    kbAccept(text) {
      alert("Input text: " + text);
      this.hide();
    },
    kbShow(e) {
      this.input = e.target;
      this.kbVisible = true;

    },
    kbHide() {
      this.kbVisible = false;
    },
    kbClose(keyboard){
      this.kbHide();
      this.$$('#searchItem')[0].f7Searchbar.disable();
      keyboard.mutate("");
    },
    setIndex(keyboard, e){
     var args = this.$$(e.target).data('args');

     var value = keyboard.value;
     if(value.match(/([A-Za-z]+)([0-9]+)/)){

       keyboard.mutate(value.replace(/([A-Za-z]+)([0-9]+)/,args+'$2'))
     }else {
       keyboard.mutate(args)
     }
   }
  },
  watch:{
    inputVal(){
      this.$$('#info input').val(this.inputVal).trigger('change')
    },
    currentStep(){
      if(this.currentStep ==-1 )
        this.currentStepLib = "Etape initial"
      else  if(this.currentStep ==-1 )
        this.currentStepLib = "Etape final"
      else {
        this.currentStepLib = "Etape " + (parseInt(this.currentStep)+1);
      }
    },
    lastSelectedObjectName(){
      if(this.lastSelectedObjectName ==""){
        this.lastSelectedObjectLib ="";
        this.lastSelectedObjectIndex = "";
      }else{
        let name = nomIndex[this.lastSelectedObjectName];
        this.lastSelectedObjectLib =name;
        this.lastSelectedObjectIndex= this.lastSelectedObjectName;
      }
    },
    locale(){
      this.setStep();
      if(this.lastSelectedObjectName ==""){
        this.lastSelectedObjectLib ="";
        this.lastSelectedObjectIndex = "";
      }else{
        let name = this.getFolderName(this.lastSelectedObjectName)[1];
        this.lastSelectedObjectLib = this.translateName(name, this.locale);
        this.lastSelectedObjectIndex= this.getIndexName(name);
      }
    }
  },
  mounted: function() {
    var self = this;
        // this.$$('#info input').data("layout", "normal")
    // return;
    this.$$('#info input').attr('readonly', 'readonly');
    this.$$('#info input').on('touchstart', function(e){
      self.kbShow(e);
      self.$$('#searchItem')[0].f7Searchbar.enable();
      return false;
    })
    this.$$('#info input').on('focus', function(){
      self.$$(this).focusout();
    })

    this.currentStep = -1;
    this.$$('#framework7-root').addClass('close-panel-right');
    this.$$('#framework7-root').addClass('close-panel-left');
    this.$$('#framework7-root').addClass('close-panel');

    visio = new visionneuse({
      'containerId': 'container3D',
      // 'loadingFilesName': ["all-merged"],
      'loadingFilesName': [fileToLoad],
      'geometries': ["all"],
      'explodedGeometries': ["all"],
      'drawingCanvasId':'drawing',
      'dom7': self.$$,
      group: false,
      'onLoadMergedFile': function (totalMesh, totalLoaded) {
         self.totalMesh = totalMesh;
         self.totalLoaded = totalLoaded;
         self.$$("#loader").hide().show(0);
      },
      onLoadcompleted:function(){
        self.isLoading = false;
           self.$$("#loader").hide();
      }
      ,
      onLoadFinished:function(){
        self.totalRendered = self.totalMesh;
        self.isLoading = false;
        self.$$('#app').addClass('loaded');
        var fileToMarkup = [];
      },
      'onLoadNextShape': function(totalRendered) {
      self.totalRendered = totalRendered;

          // setTimeout(function(){
          //
          //   visio.setObjectsOpacity("all", 0);
          //   visio.setObjectsOpacity(stepsList[0], 1);
          // },100);
          // for(let i in steps[0]){
          //   let founded = false;
          //   for (let y in currentStepList){
          //     if(currentStepList[y] == previousStepList[i]){
          //       founded = true;
          //     }
          //   }
          //   if(founded == false){
          //     fileToMarkup.push(previousStepList[i]);
          //   }
          // }

      },
      'onObjectClick':function(intersects){

        var i =0;
        var obj = null;
        do{
          var obj = intersects[i].object;
          i++;
        }while(obj.material.opacity !=1 && i < intersects.length);

        if(obj.material.opacity == 0)
          return;
        self.lastSelectedObjectName = obj.name;

        this.$$('#selectionInfo').css("display", 'block');
        visio.selectObj(obj);

        visio.stopDrawing();

        setTimeout(function(){

          let liY = self.$$("#selectionInfo").offset().top - 45;
          let liX = self.$$("#selectionInfo").offset().left - self.$$('#drawing').offset().left;

          visio.startDrawingLineToObj({x:liX, y:liY}, obj.name);
        },50);

        self.panToObjects([self.lastSelectedObjectName]);

      }
    });

    this.$$(document).on('click', '#info li', this.showObject)



  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home.vue